import { request } from '@/utils/request'

/* export const reqCustomerType = code =>
  firebaseRequest.get(`complaint?code=${code}`); */

export const reqDriverList = () => request.get(`driver/list?task=general`)

export const reqTaxiMeter = (params) =>
  request.get(`driver/taxi_meter`, { params })



// WEBPACK FOOTER //
// ./src/api/searchDriverMeter/index.js